import styled, { css } from 'styled-components';
import { defaultMuiTheme } from '../../../styles/MaterialTheme';
import { LARGE_BACKGROUND_IMAGE_SIZE_IN_PX, MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX, SMALL_BACKGROUND_IMAGE_SIZE_IN_PX, MOBILE_LARGE_BACKGROUND_IMAGE_SIZE_IN_PX, MOBILE_MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX } from './BackgroundImage';
export const CommonImageMatrixStyles = css `
    display: grid;
    grid-template-columns: 1fr 1fr;
`;
const SmallImageMatrix = styled.div `
    ${CommonImageMatrixStyles}

    grid-gap: 4px;
    height: ${SMALL_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    width: ${SMALL_BACKGROUND_IMAGE_SIZE_IN_PX}px;

    div {
        height: 26px;
        width: 26px;
        border-radius: 4px;
    }
`;
const MediumImageMatrix = styled.div `
    ${CommonImageMatrixStyles}

    grid-gap: 4px;
    height: ${MOBILE_MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    width: ${MOBILE_MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    div {
        height: 28px;
        width: 28px;
        border-radius: 4px;
    }

    ${defaultMuiTheme.breakpoints.up('sm')} {
        grid-gap: 6px;
        height: ${MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;
        width: ${MEDIUM_BACKGROUND_IMAGE_SIZE_IN_PX}px;

        div {
            height: 42px;
            width: 42px;
            border-radius: 6px;
        }
    }
`;
const LargeImageMatrix = styled.div `
    ${CommonImageMatrixStyles}

    grid-gap: 4px;
    height: ${MOBILE_LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    width: ${MOBILE_LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
    div {
        height: 30px;
        width: 30px;
        border-radius: 4px;
    }

    ${defaultMuiTheme.breakpoints.up('sm')} {
        grid-gap: 8px;
        height: ${LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
        width: ${LARGE_BACKGROUND_IMAGE_SIZE_IN_PX}px;
        div {
            height: 58px;
            width: 58px;
            border-radius: 8px;
        }
    }
`;
export default {
    Small: SmallImageMatrix,
    Medium: MediumImageMatrix,
    Large: LargeImageMatrix
};
//# sourceMappingURL=ImageMatrix.js.map